export const shoppingTipsArticleId = 434;
